var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-scaler"},[_c('div',{style:({paddingTop: _vm.paddingTop})}),_vm._v(" "),_c('div',{ref:"content",staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }